(function () {
  'use strict';

  if (window.__VSKLO_DEFAULT_SEARCH_CONTROLLER_V2__) return;
  window.__VSKLO_DEFAULT_SEARCH_CONTROLLER_V2__ = true;

  var DESKTOP_MIN_WIDTH = window.VSKLOBreakpoints ? window.VSKLOBreakpoints.desktopMin : 1025;
  var CLOSE_DURATION = 340;
  var root = document.documentElement;
  var state = {
    open: false,
    closing: false,
    closeTimer: 0,
    hadOpenDrawer: false,
    previousPaddingRight: '',
    suppressFocusOpen: false,
    resizeFrame: 0
  };

  function isDesktop() {
    if (typeof window.VSKLOIsMobile === 'function') return !window.VSKLOIsMobile();
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  function getHost() {
    return document.querySelector('header-search[data-desktop-search-type="default"]');
  }

  function getPanel() {
    var host = getHost();
    return host ? host.querySelector('[data-vsklo-default-search-panel]') : null;
  }

  function hydrateDefaultSuggestions(scope) {
    var root = scope && scope.querySelector ? scope : getPanel();
    if (!root) return;
    var template = root.querySelector('template[data-vsklo-search-default-template]');
    var mount = root.querySelector('[data-vsklo-search-default-mount]');
    if (!template || !mount || mount.getAttribute('data-vsklo-search-default-ready') === 'true') return;
    mount.appendChild(template.content.cloneNode(true));
    mount.setAttribute('data-vsklo-search-default-ready', 'true');
    try {
      document.dispatchEvent(new CustomEvent('vsklo:content-updated', { detail: { scope: mount } }));
    } catch (error) {}
  }

  window.vskloHydrateDefaultSearchSuggestions = function (scope) {
    hydrateDefaultSuggestions(scope || getPanel());
  };

  function getTrigger() {
    return document.querySelector('[data-vsklo-default-search-trigger]');
  }

  function getInput() {
    var trigger = getTrigger();
    return trigger ? trigger.querySelector('input[type="search"]') : null;
  }

  function getOverlay() {
    return document.querySelector('.overlay_search');
  }

  function getHeaderBottom() {
    var header =
      document.querySelector('.section-header .header') ||
      document.querySelector('header.header') ||
      document.querySelector('header');

    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function updateGeometry() {
    var panel = getPanel();
    if (!panel) return;
    panel.style.setProperty('--vsklo-default-search-top', getHeaderBottom() + 'px');
  }

  function setExpanded(expanded) {
    var input = getInput();
    var panel = getPanel();

    if (input) input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (!panel) return;

    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    if (expanded) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');
  }

  function lockPage() {
    if (state.open || state.closing) return;

    state.hadOpenDrawer = root.classList.contains('open-drawer');
    state.previousPaddingRight = root.style.paddingRight || '';

    if (!state.hadOpenDrawer) {
      var scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);
      if (scrollbarWidth > 0) root.style.paddingRight = scrollbarWidth + 'px';
    }

    root.classList.add('open-drawer');
  }

  function unlockPage() {
    var sharedDrawerStillOpen =
      root.classList.contains('open-minicart') ||
      root.classList.contains('nav-open') ||
      root.classList.contains('open-sidebar') ||
      root.classList.contains('open-byl') ||
      root.classList.contains('vsklo-mobile-drawer-open');

    if (!state.hadOpenDrawer && !sharedDrawerStillOpen) {
      root.classList.remove('open-drawer');
    }

    if (!state.hadOpenDrawer) {
      var overlayStillOpen =
        window.VSKLOOverlayState &&
        typeof window.VSKLOOverlayState.any === 'function' &&
        window.VSKLOOverlayState.any();
      if (!sharedDrawerStillOpen && !overlayStillOpen) {
        if (state.previousPaddingRight) root.style.paddingRight = state.previousPaddingRight;
        else root.style.removeProperty('padding-right');
      }
    }

    state.hadOpenDrawer = false;
    state.previousPaddingRight = '';
  }

  function clearCloseTimer() {
    if (!state.closeTimer) return;
    window.clearTimeout(state.closeTimer);
    state.closeTimer = 0;
  }

  function focusInput() {
    var input = getInput();
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }
  }

  function closeConflictingDesktopDrawers() {
    if (typeof window.VSKLOCloseDesktopNav === 'function') {
      window.VSKLOCloseDesktopNav();
    }

    if (root.classList.contains('open-minicart')) {
      var cart =
        document.querySelector('cart-notification#minicart_wrapper') ||
        document.querySelector('cart-drawer');
      if (cart && typeof cart.close === 'function') {
        cart.close();
      }
    }
  }

  function openSearch(focusField) {
    if (!isDesktop()) return;

    var panel = getPanel();
    var trigger = getTrigger();
    var overlay = getOverlay();
    if (!panel || !trigger) return;

    closeConflictingDesktopDrawers();
    clearCloseTimer();
    state.closing = false;
    hydrateDefaultSuggestions(panel);
    updateGeometry();

    if (!state.open) {
      lockPage();
      state.open = true;
    }

    root.classList.add('open-search');
    if (window.VSKLOOverlayState) window.VSKLOOverlayState.acquire('desktop-search');
    panel.classList.remove('is-closing');
    panel.classList.add('is-open');
    if (overlay) {
      overlay.classList.remove('is-closing');
      overlay.classList.add('open');
    }
    setExpanded(true);

    if (focusField) focusInput();
  }

  function finishClose(returnFocus) {
    var panel = getPanel();
    var overlay = getOverlay();

    state.closeTimer = 0;
    state.closing = false;
    state.open = false;

    if (panel) panel.classList.remove('is-open', 'is-closing');
    if (overlay) overlay.classList.remove('open', 'is-closing');
    setExpanded(false);

    root.classList.remove('open-search');
    if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('desktop-search');
    unlockPage();

    if (returnFocus) {
      state.suppressFocusOpen = true;
      focusInput();
      window.setTimeout(function () {
        state.suppressFocusOpen = false;
      }, 0);
    }
  }

  function closeSearch(returnFocus) {
    var panel = getPanel();
    var overlay = getOverlay();

    if (state.closing || !state.open || !panel) return;

    clearCloseTimer();
    state.closing = true;

    panel.classList.remove('is-open');
    panel.classList.add('is-closing');
    if (overlay) {
      overlay.classList.remove('open');
      overlay.classList.add('is-closing');
    }
    setExpanded(false);

    state.closeTimer = window.setTimeout(function () {
      finishClose(returnFocus);
    }, CLOSE_DURATION);
  }

  window.VSKLOCloseDesktopSearch = function (returnFocus, immediate) {
    if (!state.open && !state.closing) return false;
    if (immediate) {
      clearCloseTimer();
      finishClose(Boolean(returnFocus));
      return true;
    }
    closeSearch(Boolean(returnFocus));
    return true;
  };

  document.addEventListener('focusin', function (event) {
    if (state.suppressFocusOpen || !isDesktop()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-vsklo-default-search-trigger]')) openSearch(false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var closeButton = target.closest('[data-vsklo-default-search-close]');
    if (closeButton) {
      event.preventDefault();
      closeSearch(true);
      return;
    }

    var trigger = target.closest('[data-vsklo-default-search-trigger]');

    if (trigger && isDesktop()) {
      var input = getInput();
      var searchButton = target.closest('button[type="submit"]');

      if (!input || !input.value.trim()) {
        event.preventDefault();
        openSearch(true);

        window.requestAnimationFrame(function () {
          focusInput();
        });

        return;
      }

      if (searchButton) {
        openSearch(false);
        return;
      }

      openSearch(true);

      window.requestAnimationFrame(function () {
        focusInput();
      });

      return;
    }

    if (!state.open && !state.closing) return;

    var panel = getPanel();
    if (panel && panel.contains(target)) return;
    closeSearch(false);
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!state.open && !state.closing) return;
      var target = event.target;
      if (!target || !target.closest || !target.closest('.overlay_search')) return;

      event.preventDefault();
      event.stopPropagation();
      closeSearch(false);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || (!state.open && !state.closing)) return;
    event.preventDefault();
    closeSearch(true);
  });

  document.addEventListener('vsklo:desktop-search-close', function () {
    if (!state.open && !state.closing) return;
    closeSearch(false);
  });

  window.addEventListener(
    'resize',
    function () {
      if (state.resizeFrame) window.cancelAnimationFrame(state.resizeFrame);
      state.resizeFrame = window.requestAnimationFrame(function () {
        state.resizeFrame = 0;
        if (!state.open && !state.closing) return;
        if (!isDesktop()) {
          clearCloseTimer();
          finishClose(false);
          return;
        }
        updateGeometry();
      });
    },
    { passive: true }
  );

  document.addEventListener('shopify:section:load', function () {
    if (state.open || state.closing) {
      clearCloseTimer();
      finishClose(false);
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    if (state.open || state.closing) {
      clearCloseTimer();
      finishClose(false);
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;
    if (state.open || state.closing) {
      clearCloseTimer();
      finishClose(false);
    }
  });
})();
